import loadImage from 'blueimp-load-image';

(function ($) {
  $.extend({
    uploadPreview : function (options) {

      // Options + Defaults
      var settings = $.extend({
        input_field: ".image-input",
        preview_box: ".image-preview",
        label_field: ".image-label",
        label_default: "Choose File",
        label_selected: "Change File",
        error_selector: ".image-error",
        no_label: false,
        success_callback : null,
      }, options);

      // Check if FileReader is available
      if (window.File && window.FileList && window.FileReader) {
        if (typeof($(settings.input_field)) !== "undefined" && $(settings.input_field) !== null) {
          $(settings.input_field).change(function() {
            var files = this.files;

            if (files.length > 0) {
              var file = files[0];

              if(file.size > 3000000) {
                $(settings.error_selector).text("Image size should be less than 3Mb.");
                $(settings.error_selector).show();
                return;
              }

              var options = {
                maxWidth: 240,
                canvas: true,
                pixelRatio: window.devicePixelRatio,
                downsamplingRatio: 0.5,
                orientation: 1,
              }

              if (!loadImage(file,
                  function (img) {

                    $(settings.error_selector).hide();

                    if(img.height > 1000 || img.width > 1000 ) {
                      $(settings.error_selector).text("Image size should be less than 1000 x 1000.");
                      $(settings.error_selector).show();
                      return;
                    }

                    if (!(img.src || img instanceof HTMLCanvasElement)) {

                      $(settings.error_selector).text("This file type is not supported.");
                      $(settings.error_selector).show();
                      return;

                    } else {

                      $(settings.preview_box).css("background-image", "url("+img.toDataURL()+")");
                      $(settings.preview_box).css("background-size", "cover");
                      $(settings.preview_box).css("background-position", "center center");
                      return true;
                    }
                  },
                  options
                )) {
                $(settings.error_selector).text("This file type is not supported.");
                $(settings.error_selector).show();
                return;
              }

              if (settings.no_label == false) {
                // Change label
                $(settings.label_field).html(settings.label_selected);
              }

              // Success callback function call
              if(settings.success_callback) {
                settings.success_callback();
              }
            } else {
              if (settings.no_label == false) {
                // Change label
                $(settings.label_field).html(settings.label_default);
              }

              // Clear background
              $(settings.preview_box).css("background-image", "none");

              // Remove Audio
              $(settings.preview_box + " audio").remove();
            }
          });
        }
      } else {
        $(settings.error_selector).text("You need a browser with file reader support, to use this form properly.");
        $(settings.error_selector).show();
        return false;
      }
    },
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/mulberrys/profile-image-preview.js